export const UPDATE_TOKEN = 'UPDATE_TOKEN'

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'

/**
 * 当前用户的权限列表
 */
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'

/**
 * 年度、期次下拉
 */
export const UPDATE_YEAR_PERIOD = 'update_year_period'

export const UPDATE_BUSINESSTYPE = 'update_business_type'

/**
 * 暗检创建任务时的有效日期下拉
 */
export const UPDATE_VALID_MONTHS = 'update_valid_months'

/**
 * 设置页面缓存
 */
export const SET_PAGE_CACHE = 'set_page_cache'

/**
 * 更新下拉框数据
 */
export const UPDATE_SELECT = {
  /**
          * 任务类型、业务类型下拉列表
          */
  BUSINESS_TYPE: 'update_select.business_type',
  /**
          * 子任务类型
          */
  CHILD_TASK_TYPE: 'update_select.child_task_type',
  /**
          * 异常运营类型
          */
  ABNORMAL_CATEGORY: 'update_select.abnormal_category'
}
